// extracted by mini-css-extract-plugin
module.exports = {"page":"error_page__par2Z","content":"error_content__mM22z","eyebrow":"error_eyebrow__TYzoH","title":"error_title__TL5pr","description":"error_description__TN8gy"};